import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';

const TableItems = ({ columns, rows, emptyRows }) => {

    return (
        <TableBody>
            {rows.length > 0 ?

                rows.map((row , idx) => {
                    
                    return (
                        <TableRow
                            hover
                            tabIndex={-1}
                            key={idx}
                            sx={{ cursor: 'pointer' }}
                        >
                            {columns.map((column) => {
                                const value = row[column.id];
                                return (
                                    <TableCell key={column.id} align={column.align}>
                                        {column.format && typeof value === 'number'
                                            ? column.format(value)
                                            : value
                                        }
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    );
                })
                :
                <TableRow>
                    <TableCell colSpan={6} key={'1'}>
                        No Items Available ...
                    </TableCell>
                </TableRow>
            }
        </TableBody>

    )
}

export default TableItems;